<template>
  <div class="order-box">
    <div class="col p-0">
      <div class="row order-title m-0 pb-1 pt-1">
        <div class="col-8 p-0" style="line-height: 38px">Mesa # {{ value.mesa }}</div>
        <div class="col-4 p-0">
          <div class="d-flex float-right">
            <div class="info-orden" @click="click">
              <i class="fa fa-info-circle" aria-hidden="true"></i>
            </div>
            <div class="info-orden" @click="imprimirTicket(value.ordenId)">
              <i class="fa fa-print" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row order-body" style="">
        Folio: <span>{{ value.folio }}</span>
      </div>
      <div class="row order-body" style="">
        Total: <span>${{ value.total }}</span>
      </div>
      <div class="row align-self-end mt-auto">
        <div class="col-5 pr-0">
          <button
            class="btn btn-secondary agregar"
            style="width: 100%;"
            data-toggle="tooltip" data-placement="top" title="Tooltip on top"
            type="button"
            @click="agregarConsumo"
          >
            Agregar 
          </button>
        </div>

        <div class="col-7 pl-2">
          <button
            class="btn btn-danger agregar"
            style="width: 100%;"
            type="button"
            @click="atenderOrden"
          >
            Cobrar Cuenta
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],

  methods: {
    atenderOrden() {
      // this.value.atendido = true;
      this.$router.push({
        name: "ResCheckout",
        params: { ordenId: this.value.ordenId },
      });
    },
    agregarConsumo() {
      this.$router.push({
        name: "ResHerisOrdenesEdit",
        params: { ordenId: this.value.ordenId },
      });
    },
    imprimirTicket(id){
      var routeData = this.$router.resolve({
          name: 'PrintTicketV2', 
          params: {ordenId: id}
      });
      var f = window.open(routeData.href, '_blank', 'location=yes,height=100,width=100,scrollbars=yes,status=yes');
      f.moveTo(0, 0);
      f.blur();
      window.focus();
      self.focus();
    }, 
    click(){
      this.$emit('click', this.value, "sucursal");
    }
  },
};
</script>

<style scoped>
.order-box {
  width: 270px;
  border: 1px solid lightgrey;
  border-radius: 5px;
  border-collapse: collapse;
  padding: 10px 15px;
  padding-top: 7px;
  min-width: 150px;
  min-height: 75px;
  max-width: 270px;
  margin: 25px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15), 0 3px 10px 0 rgba(0, 0, 0, 0.06);
  transition-property: box-shadow;
  transition-duration: 0.7s;
}

.btn.btn-primary.agregar {
  height: 34px;
  width: 25%;
  min-width: 75px;
  max-width: 150px;
}

.order-box:hover {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
}

.order-title {
  text-align: left;
  border-bottom: 1px solid lightgrey;
  font-size: 20px;
}

.row.order-body {
  justify-content: space-between;
  margin: 15px 0;
  font-size: 16px;
}

.order-box.entrega {
  min-width: 220px;
  min-height: 75px;
  max-width: 350px;
}

.info-orden{
  width: 30px;
  height: 30px;
  background-color: #4f5b60;
  color: white;
  border-radius: 5px;
  margin: 3px;
  margin-bottom: 5px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  cursor: pointer;
  transition-property: background;
}

.info-orden:hover(){
  background-color: #545b62 !important;
}
</style>
